// extracted by mini-css-extract-plugin
module.exports = {"full-bleed":"ImageSection_full-bleed__9igCh","image":"ImageSection_image__u4eLn","contained":"ImageSection_contained__QLPN_"};